import { UrlParams } from '@app/lib/http/client/contracts/UrlParams';
import { QueryParams, QueryParamValue } from '@app/lib/http/client/contracts/QueryParams';

export class UrlBuilder {
    static build(
        baseUrl: string,
        path: string | null = null,
        params: UrlParams | null = null,
        query: QueryParams | null = null,
    ): string {
        const builder = new UrlBuilder();

        let url = builder.constructUrl(baseUrl, path);

        if (query) {
            url += builder.constructQuery(query);
        }

        if (!params) {
            return url;
        }

        for (const key of Object.keys(params)) {
            url = url.replace(`:${key}`, params[key]);
        }

        return url;
    }

    constructUrl(baseUrl: string, path: string | null = null): string {
        const normalizedBaseUrl =
            baseUrl.slice(-1) === '/' ? baseUrl.slice(0, Math.max(0, baseUrl.length - 1)) : baseUrl;

        if (path === null) {
            return normalizedBaseUrl;
        }

        const normalizedPath = path.slice(0, 1) === '/' ? path.slice(1, 1 + path.length) : path;

        if (/https?:/.test(path)) {
            return normalizedPath;
        }

        return `${normalizedBaseUrl}/${normalizedPath}`;
    }

    constructQuery(query: QueryParams): string {
        const queryString = Object.keys(query)
            .reduce<[string, QueryParamValue][]>((params, key) => {
                const value = query[key];

                if (value === undefined) {
                    return params;
                }

                if (Array.isArray(value)) {
                    for (const v of value) {
                        if (v === undefined) {
                            continue;
                        }

                        params.push([key, v]);
                    }

                    return params;
                }

                params.push([key, value]);

                return params;
            }, [])
            .map(([key, value]) => this.buildQueryValue(key, value))
            .join('&');

        return `?${queryString}`;
    }

    encodeUriComponent(uriComponent: QueryParamValue): string {
        return encodeURIComponent(uriComponent)
            .replace(/%3a/gi, ':')
            .replace(/%24/gi, '$')
            .replace(/%2c/gi, ',')
            .replace(/%20/gi, '+')
            .replace(/%5b/gi, '[')
            .replace(/%5d/gi, ']');
    }

    private buildQueryValue(key: string, value: QueryParamValue): string {
        return `${this.encodeUriComponent(key)}=${this.encodeUriComponent(value)}`;
    }
}
